export const RAWDATA = 'RAWDATA'
export const DONE = 'DONE'
export const PRODUCTRAWDATA = 'PRODUCTRAWDATA'
export const FLASH_TEXT_ORGN = 'FLASH_TEXT_ORGN'
export const SPACEY_ORGN = 'SPACEY_ORGN'
export const STATES = 'STATES'
export const EMAILS_ITEM_REFS = 'EMAILS_ITEM_REFS'
export const SIDEBAR = 'SIDEBAR'
export const ALLOWED_SECTORS = 'ALLOWED_SECTORS'
export const CURRENT_ACTIVE_MODULE = 'CURRENT_ACTIVE_MODULE'
export const USER_ID = 'USER_ID'
export const BIG_LOADING = 'BIG_LOADING'
export const DASHBOARD_TYPE = 'DASHBOARD_TYPE'
// export const UPDATED_CHECKBOX = 'UPDATED_CHECKBOX'